import ReactDOM from 'react-dom/client'
import { ToastContainer } from 'react-toastify'
import App from './App'
import { AnalyticsProvider } from './context/analyticsContext'
import './styles/ads.css'
import './styles/index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AnalyticsProvider>
    <App />
    <ToastContainer autoClose={false} />
  </AnalyticsProvider>
)
